
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("32CBT", function(module, exports) {

$parcel$export(module.exports, "PublishModal", () => $fc08d04e21e26787$export$947d923eb7e59d5c);
$parcel$export(module.exports, "DiscardModal", () => $fc08d04e21e26787$export$5a1c1fd1fd0d9704);
$parcel$export(module.exports, "CancelSchedulePublishModal", () => $fc08d04e21e26787$export$6bd5113474000445);

var $jmjWc = parcelRequire("jmjWc");

const $fc08d04e21e26787$export$947d923eb7e59d5c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "3GQfQ",
    name: "PublishModal",
    loader: async ()=>{
        return (await (parcelRequire("d3zYy"))).PublishModal;
    }
});

const $fc08d04e21e26787$export$5a1c1fd1fd0d9704 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5nfIQ",
    name: "DiscardModal",
    loader: async ()=>{
        return (await (parcelRequire("bWOSY"))).DiscardModal;
    }
});

const $fc08d04e21e26787$export$6bd5113474000445 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Xm8EX",
    name: "CancelSchedulePublishModal",
    loader: async ()=>{
        return (await (parcelRequire("63FfH"))).CancelSchedulePublishModal;
    }
});

});
parcelRegister("d3zYy", function(module, exports) {

let $9817762e44f0dcf1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9817762e44f0dcf1$var$load("cuVen"),
    $9817762e44f0dcf1$var$load("7X74w"),
    $9817762e44f0dcf1$var$load("2zJ0a"),
    $9817762e44f0dcf1$var$load("anQQJ")
]).then(()=>parcelRequire('9V1Xo'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});



parcelRegister("bWOSY", function(module, exports) {

let $8b2c95507bdde37d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8b2c95507bdde37d$var$load("fCqMy").then(()=>parcelRequire('hpcRG'));

});

parcelRegister("63FfH", function(module, exports) {

let $469305bf06dbddda$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $469305bf06dbddda$var$load("a6uKK").then(()=>parcelRequire('ic1wA'));

});


parcelRegister("ibgjl", function(module, exports) {

$parcel$export(module.exports, "PublishModalContext", () => $8e5ec683a0a81bad$export$5bbc09a836707eff);
$parcel$export(module.exports, "withPublishModalContextProvider", () => $8e5ec683a0a81bad$export$c88291018b2907cc);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $atveb = parcelRequire("atveb");

var $gqqjz = parcelRequire("gqqjz");
var $7aRa9 = parcelRequire("7aRa9");

var $ep3mz = parcelRequire("ep3mz");

var $bT0se = parcelRequire("bT0se");

var $8mrqR = parcelRequire("8mrqR");
var $eHlnk = parcelRequire("eHlnk");

var $jVFPV = parcelRequire("jVFPV");
const $8e5ec683a0a81bad$var$DEFAULT_SETTINGS = {
    pendingScheduledPublishDate: undefined,
    versionComments: '',
    publishAsBlog: false,
    shouldNotify: true,
    moveParams: undefined,
    restrictionsRestObj: undefined
};
const $8e5ec683a0a81bad$export$df066e33be73e48e = ()=>Promise.resolve({
        title: '',
        adf: {
            type: ''
        }
    });
const $8e5ec683a0a81bad$export$5bbc09a836707eff = /*#__PURE__*/ (0, $gwFzn.createContext)({
    ...$8e5ec683a0a81bad$var$DEFAULT_SETTINGS,
    currentlyScheduledPublishDate: undefined,
    setCurrentlyScheduledPublishDate: ()=>{},
    setPendingScheduledPublishDate: ()=>{},
    scheduledPublishDate: undefined,
    setVersionComments: ()=>{},
    setPublishAsBlog: ()=>{},
    expanded: false,
    setExpanded: ()=>{},
    setShouldNotify: ()=>{},
    setRestrictionsRestObj: ()=>{},
    hasModifiedRestrictions: false,
    refetchAll: ()=>{},
    shouldNotifyComputedValue: true,
    discardCurrentState: ()=>{},
    graphqlError: undefined,
    restrictionsGraphQLError: undefined,
    onClickPublish: ()=>{},
    onClickPreview: ()=>{},
    retrieveEditorTitleAndContent: $8e5ec683a0a81bad$export$df066e33be73e48e,
    flags: new (0, $gqqjz.FlagsStateContainer)([]),
    hasModifiedSettings: true,
    isBlog: false,
    setIsBlog: ()=>{},
    setMoveParams: ()=>{},
    hasModifiedLocation: false,
    hasScheduledRestrictions: false,
    setHasScheduledRestrictions: ()=>{},
    isConvertToPageDialog: false
});
const $8e5ec683a0a81bad$export$d831d07c578114dd = ()=>{
    const [currentlyScheduledPublishDate, setCurrentlyScheduledPublishDate] = (0, $gwFzn.useState)(undefined);
    const [pendingScheduledPublishDate, setPendingScheduledPublishDate] = (0, $gwFzn.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.pendingScheduledPublishDate);
    const [versionComments, setVersionComments] = (0, $gwFzn.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.versionComments);
    const [publishAsBlog, setPublishAsBlog] = (0, $gwFzn.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.publishAsBlog);
    const [expanded, setExpanded] = (0, $gwFzn.useState)(false);
    const [shouldNotify, setShouldNotify] = (0, $gwFzn.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.shouldNotify);
    // undefined indicates that no user-initiated changes have been mode to restrictions
    const [restrictionsRestObj, setRestrictionsRestObj] = (0, $gwFzn.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.restrictionsRestObj);
    const [savedSnapshot, setSavedSnapshot] = (0, $gwFzn.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS);
    const [hasScheduledRestrictions, setHasScheduledRestrictions] = (0, $gwFzn.useState)(false);
    const [isBlog, setIsBlog] = (0, $gwFzn.useState)(false);
    const [moveParams, setMoveParams] = (0, $gwFzn.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.moveParams);
    // When the publish modal opens and a date is already scheduled on the backend,
    // the pendingScheduledPublishDate is set to undefined to indicate there is
    // no date picked by the user, while the currentlyScheduledPublishDate will
    // have the actualy scheduled date value.
    // This check prevents that situation from triggering the discard dialog.
    const hasModifiedDate = currentlyScheduledPublishDate?.getTime() !== pendingScheduledPublishDate?.getTime() && pendingScheduledPublishDate !== undefined;
    const hasModifiedRestrictions = restrictionsRestObj !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(savedSnapshot.restrictionsRestObj, restrictionsRestObj);
    const hasModifiedLocation = savedSnapshot.publishAsBlog !== publishAsBlog || savedSnapshot.moveParams !== moveParams;
    const hasModifiedSettings = hasModifiedDate || savedSnapshot.versionComments !== versionComments || savedSnapshot.shouldNotify !== shouldNotify || hasModifiedLocation || hasModifiedRestrictions;
    /* Function to discard current state on modal close */ const discardCurrentState = ()=>{
        setPendingScheduledPublishDate($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.pendingScheduledPublishDate);
        setVersionComments($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.versionComments);
        setPublishAsBlog($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.publishAsBlog);
        setShouldNotify($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.shouldNotify);
        setMoveParams($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.moveParams);
        setRestrictionsRestObj($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.restrictionsRestObj);
        setSavedSnapshot($8e5ec683a0a81bad$var$DEFAULT_SETTINGS);
    };
    const scheduledPublishDate = pendingScheduledPublishDate ?? currentlyScheduledPublishDate;
    return {
        currentlyScheduledPublishDate: currentlyScheduledPublishDate,
        setCurrentlyScheduledPublishDate: setCurrentlyScheduledPublishDate,
        pendingScheduledPublishDate: pendingScheduledPublishDate,
        setPendingScheduledPublishDate: setPendingScheduledPublishDate,
        versionComments: versionComments,
        setVersionComments: setVersionComments,
        publishAsBlog: publishAsBlog,
        setPublishAsBlog: setPublishAsBlog,
        expanded: expanded,
        setExpanded: setExpanded,
        shouldNotify: shouldNotify,
        setShouldNotify: setShouldNotify,
        restrictionsRestObj: restrictionsRestObj,
        setRestrictionsRestObj: setRestrictionsRestObj,
        hasModifiedRestrictions: hasModifiedRestrictions,
        scheduledPublishDate: scheduledPublishDate,
        discardCurrentState: discardCurrentState,
        savedSnapshot: savedSnapshot,
        setSavedSnapshot: setSavedSnapshot,
        hasModifiedSettings: hasModifiedSettings,
        isBlog: isBlog,
        setIsBlog: setIsBlog,
        setMoveParams: setMoveParams,
        moveParams: moveParams,
        hasModifiedLocation: hasModifiedLocation,
        hasScheduledRestrictions: hasScheduledRestrictions,
        setHasScheduledRestrictions: setHasScheduledRestrictions
    };
};
const $8e5ec683a0a81bad$export$d24968a4528c903e = (0, $7aRa9.withFlags)(({ children: children, onClickPublish: onClickPublish, onClickPreview: onClickPreview, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, flags: flags, isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, isConvertToPageDialog: isConvertToPageDialog = false })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    /* State declarations */ const { currentlyScheduledPublishDate: currentlyScheduledPublishDate, setCurrentlyScheduledPublishDate: setCurrentlyScheduledPublishDate, pendingScheduledPublishDate: pendingScheduledPublishDate, setPendingScheduledPublishDate: setPendingScheduledPublishDate, versionComments: versionComments, setVersionComments: setVersionComments, publishAsBlog: publishAsBlog, setPublishAsBlog: setPublishAsBlog, expanded: expanded, setExpanded: setExpanded, shouldNotify: shouldNotify, setShouldNotify: setShouldNotify, restrictionsRestObj: restrictionsRestObj, setRestrictionsRestObj: setRestrictionsRestObj, hasModifiedRestrictions: hasModifiedRestrictions, scheduledPublishDate: scheduledPublishDate, discardCurrentState: discardCurrentState, savedSnapshot: savedSnapshot, setSavedSnapshot: setSavedSnapshot, hasModifiedSettings: hasModifiedSettings, isBlog: isBlog, setIsBlog: setIsBlog, setMoveParams: setMoveParams, moveParams: moveParams, hasModifiedLocation: hasModifiedLocation, hasScheduledRestrictions: hasScheduledRestrictions, setHasScheduledRestrictions: setHasScheduledRestrictions } = $8e5ec683a0a81bad$export$d831d07c578114dd();
    const onSchedulePublishPubsubEvent = (0, $gwFzn.useCallback)((_, payload)=>{
        const { schedulePublishRequestBody: { publishTime: publishTime, eventType: eventType } } = payload;
        if (eventType === 'scheduled') {
            if (!currentlyScheduledPublishDate || currentlyScheduledPublishDate?.toISOString() !== publishTime) setCurrentlyScheduledPublishDate(new Date(publishTime));
        } else if (eventType === 'unscheduled') {
            if (currentlyScheduledPublishDate) setCurrentlyScheduledPublishDate(undefined);
        }
    }, [
        currentlyScheduledPublishDate,
        setCurrentlyScheduledPublishDate
    ]);
    (0, $bT0se.usePubSubEvent)({
        contentId: contentId ?? '',
        contentType: contentType ?? 'page',
        eventName: contentType === 'blogpost' ? 'schedulePublish:blogpost' : 'schedulePublish:page',
        onEvent: onSchedulePublishPubsubEvent
    });
    const { error: restrictionsGraphQLError, refetch: refetchRestrictions } = (0, $eHlnk.useFetchRestrictionsRESTObj)({
        contentId: contentId ?? '',
        onSuccess: (newRestrictions)=>// Snapshot should match scheduled restrictions instead of true restrictions
            !hasScheduledRestrictions && setSavedSnapshot({
                ...savedSnapshot,
                restrictionsRestObj: newRestrictions
            })
    });
    const isFirstTimeBlogPost = isUnpublishedDraft && isBlog;
    let shouldNotifyComputedValue = shouldNotify;
    const computedRestrictions = hasModifiedRestrictions ? restrictionsRestObj : savedSnapshot.restrictionsRestObj;
    if (computedRestrictions && (0, $8mrqR.restrictionsArePrivateToYouOnly)(computedRestrictions)) shouldNotifyComputedValue = false;
    else if (publishAsBlog || isFirstTimeBlogPost) shouldNotifyComputedValue = true;
    const loadQueryDataIntoPublishModalState = (newQueryData)=>{
        let nextCurrentlyScheduledPublishDate;
        let nextPendingScheduledPublishDate;
        let nextExpanded = expanded;
        let nextShouldNotify;
        let nextPublishAsBlog = publishAsBlog;
        let nextRestrictionsRestObj = restrictionsRestObj;
        let nextmoveParams = moveParams;
        const schedulePublishInfo = newQueryData?.singleContent?.schedulePublishInfo;
        if (schedulePublishInfo?.date) {
            nextCurrentlyScheduledPublishDate = new Date(Date.parse(schedulePublishInfo?.date));
            nextPendingScheduledPublishDate = undefined;
            nextExpanded = true;
        } else {
            nextCurrentlyScheduledPublishDate = undefined;
            nextPendingScheduledPublishDate = undefined;
        }
        const nextVersionComments = schedulePublishInfo?.versionComment ?? '';
        if (typeof schedulePublishInfo?.minorEdit === 'boolean') // if minorEdit==false then we should notify
        nextShouldNotify = !schedulePublishInfo?.minorEdit;
        else // if we don't have a value for this, set to true which is the default
        nextShouldNotify = true;
        nextPublishAsBlog = schedulePublishInfo?.targetType === 'blogpost' && newQueryData?.singleContent?.type !== 'blogpost';
        const targetLocation = schedulePublishInfo?.targetLocation;
        if (targetLocation?.destinationSpace?.key) {
            nextmoveParams = {
                newSpaceKey: targetLocation?.destinationSpace?.alias || targetLocation?.destinationSpace?.key
            };
            if (targetLocation?.parentId) nextmoveParams = {
                ...nextmoveParams,
                newParentPageId: targetLocation?.parentId
            };
        }
        if (schedulePublishInfo?.restrictions) {
            setHasScheduledRestrictions(true);
            nextRestrictionsRestObj = (0, $jVFPV.convertRestrictionsObjFromSchedulePublishInfo)(schedulePublishInfo?.restrictions);
        }
        setCurrentlyScheduledPublishDate(nextCurrentlyScheduledPublishDate);
        setPendingScheduledPublishDate(nextPendingScheduledPublishDate);
        setExpanded(nextExpanded);
        setVersionComments(nextVersionComments);
        setShouldNotify(nextShouldNotify);
        setPublishAsBlog(nextPublishAsBlog);
        setRestrictionsRestObj(nextRestrictionsRestObj);
        setMoveParams(nextmoveParams);
        // TODO: GENI-2751 - Read staged locations from schedule publish info
        // and stage to snapshot with moveParams
        setSavedSnapshot((oldSavedSnapshot)=>({
                pendingScheduledPublishDate: nextPendingScheduledPublishDate,
                versionComments: nextVersionComments,
                publishAsBlog: nextPublishAsBlog,
                shouldNotify: nextShouldNotify,
                moveParams: nextmoveParams,
                // If savedSnapshot.restrictionsRestObj has just been set by useFetchRestrictionsRESTObj, we need to not override what it just set.
                restrictionsRestObj: nextRestrictionsRestObj ?? oldSavedSnapshot.restrictionsRestObj
            }));
    };
    /* Fetching already scheduled publish data */ const { data: queryData, error: graphqlError, refetch: refetchPublishModalQuery } = (0, $diswb.useQuery)((0, $d2LG0.default)`query PublishModalContextPublishModalWithMoreOptionsQuery($contentId:ID){singleContent(id:$contentId){id type space{id}schedulePublishInfo{date versionComment minorEdit targetType targetLocation{parentId destinationSpace{id key alias}}restrictions{update{user{edges{node{email permissionType displayName accountId publicName profilePicture{path}}}}group{edges{node{name id}}}}read{user{edges{node{email permissionType displayName accountId publicName profilePicture{path}}}}group{edges{node{name id}}}}}}}}`, {
        errorPolicy: 'all',
        fetchPolicy: 'cache-and-network',
        variables: {
            contentId: contentId
        },
        onCompleted: loadQueryDataIntoPublishModalState
    });
    (0, $gwFzn.useEffect)(()=>{
        const schedulePublishDateFromQuery = queryData?.singleContent?.schedulePublishInfo?.date;
        if (schedulePublishDateFromQuery) {
            const newSchedulePublishDateFromQuery = new Date(Date.parse(schedulePublishDateFromQuery));
            setCurrentlyScheduledPublishDate(newSchedulePublishDateFromQuery);
        }
    }, [
        queryData?.singleContent?.schedulePublishInfo?.date,
        setCurrentlyScheduledPublishDate
    ]);
    const resetToInitialState = ()=>{
        if (queryData?.singleContent?.schedulePublishInfo?.date) // If this page is currently scheduled to be published,
        // then load the settings of the current scheduled publish from the backend.
        loadQueryDataIntoPublishModalState(queryData);
        else discardCurrentState();
    };
    const refetchAll = (0, $gwFzn.useCallback)(()=>{
        refetchPublishModalQuery();
        refetchRestrictions();
    }, [
        refetchPublishModalQuery,
        refetchRestrictions
    ]);
    /* Objects that are provided via the context */ const contextProvidedData = {
        currentlyScheduledPublishDate: currentlyScheduledPublishDate,
        setCurrentlyScheduledPublishDate: setCurrentlyScheduledPublishDate,
        pendingScheduledPublishDate: pendingScheduledPublishDate,
        setPendingScheduledPublishDate: setPendingScheduledPublishDate,
        scheduledPublishDate: scheduledPublishDate,
        versionComments: versionComments,
        setVersionComments: setVersionComments,
        publishAsBlog: publishAsBlog,
        setPublishAsBlog: setPublishAsBlog,
        expanded: expanded,
        setExpanded: setExpanded,
        shouldNotify: shouldNotify,
        setShouldNotify: setShouldNotify,
        restrictionsRestObj: computedRestrictions,
        setRestrictionsRestObj: setRestrictionsRestObj,
        hasModifiedRestrictions: hasModifiedRestrictions,
        refetchAll: refetchAll,
        shouldNotifyComputedValue: shouldNotifyComputedValue,
        graphqlError: graphqlError,
        restrictionsGraphQLError: restrictionsGraphQLError,
        discardCurrentState: resetToInitialState,
        onClickPublish: onClickPublish,
        onClickPreview: onClickPreview,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        flags: flags,
        hasModifiedSettings: hasModifiedSettings,
        isBlog: isBlog,
        setIsBlog: setIsBlog,
        setMoveParams: setMoveParams,
        moveParams: moveParams,
        hasModifiedLocation: hasModifiedLocation,
        hasScheduledRestrictions: hasScheduledRestrictions,
        setHasScheduledRestrictions: setHasScheduledRestrictions,
        isConvertToPageDialog: isConvertToPageDialog
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8e5ec683a0a81bad$export$5bbc09a836707eff.Provider, {
        value: contextProvidedData
    }, children);
});
const $8e5ec683a0a81bad$export$c88291018b2907cc = (WrappedComponent)=>({ onClickPublish: onClickPublish, onClickPreview: onClickPreview, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, isConvertToPageDialog: isConvertToPageDialog, ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8e5ec683a0a81bad$export$d24968a4528c903e, {
            onClickPublish: onClickPublish,
            onClickPreview: onClickPreview,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
            isUnpublishedDraft: isUnpublishedDraft,
            contentType: contentType,
            isConvertToPageDialog: isConvertToPageDialog
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(WrappedComponent, {
            isUnpublishedDraft: isUnpublishedDraft,
            contentType: contentType,
            ...props
        }));
    };

});
parcelRegister("eHlnk", function(module, exports) {

$parcel$export(module.exports, "useFetchRestrictionsRESTObj", () => $0881c56c6dd240f3$export$8596aed048cdf431);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $inPa6 = parcelRequire("inPa6");

var $7PLO8 = parcelRequire("7PLO8");

var $6mBn8 = parcelRequire("6mBn8");

var $8mrqR = parcelRequire("8mrqR");
const $0881c56c6dd240f3$export$8596aed048cdf431 = ({ contentId: contentId, onSuccess: onSuccess })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [transformationError, setTransformationError] = (0, $gwFzn.useState)(undefined);
    const { data: data, error: error, refetch: refetch } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $6mBn8.RestrictionsRESTQuery), {
        variables: {
            contentId: contentId,
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        // Without this setting, onCompleted will not fire on refetches
        // See: https://github.com/apollographql/react-apollo/issues/3709#issuecomment-592786578
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        onCompleted: (completedData)=>{
            try {
                onSuccess?.((0, $8mrqR.transformGraphQLQueryToRESTObj)(completedData));
                setTransformationError(undefined);
            } catch (restrictionsError) {
                setTransformationError(restrictionsError);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'error',
                        actionSubject: 'fetchRestrictions',
                        actionSubjectId: 'fetchRestrictionsError',
                        source: 'useFetchRestrictionsRESTObj',
                        attributes: {
                            message: restrictionsError.message
                        }
                    }
                }).fire();
            }
        }
    });
    const fetchedRestrictions = (0, $gwFzn.useMemo)(()=>{
        if (data) {
            let transformedData = undefined;
            try {
                transformedData = (0, $8mrqR.transformGraphQLQueryToRESTObj)(data);
            } catch (restrictionsError) {
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'error',
                        actionSubject: 'fetchRestrictions',
                        actionSubjectId: 'fetchRestrictionsError',
                        source: 'useFetchRestrictionsRESTObj',
                        attributes: {
                            message: restrictionsError.message
                        }
                    }
                }).fire();
            }
            return transformedData;
        } else return undefined;
    }, [
        data,
        createAnalyticsEvent
    ]);
    return {
        fetchedRestrictions: fetchedRestrictions,
        error: error || transformationError,
        refetch: refetch
    };
};

});
parcelRegister("6mBn8", function(module, exports) {

$parcel$export(module.exports, "RestrictionsRESTQuery", () => $ffce6633f89b6129$export$621c0bbb0734dedd);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $ffce6633f89b6129$export$621c0bbb0734dedd = (0, $d2LG0.default)`query RestrictionsRESTQuery($contentId:ID!$draftShareId:String){content(id:$contentId status:["current" "draft"]draftShareId:$draftShareId){nodes{id type restrictions{read{operation restrictions{groupWithRestrictions{nodes{id name}}userWithRestrictions{nodes{accountId displayName email hasSpaceEditPermission hasSpaceViewPermission permissionType publicName profilePicture{path}type}}}}update{operation restrictions{groupWithRestrictions{nodes{id name}}userWithRestrictions{nodes{accountId displayName email hasSpaceEditPermission hasSpaceViewPermission permissionType publicName profilePicture{path}type}}}}}}}}`;

});



parcelRegister("4f2ij", function(module, exports) {

$parcel$export(module.exports, "PublishModalDialogs", () => $5ded9942f908b7ae$export$2ade9573a6e2bedc);

var $gwFzn = parcelRequire("gwFzn");

var $6xdDU = parcelRequire("6xdDU");

var $9wGTI = parcelRequire("9wGTI");

var $ep3mz = parcelRequire("ep3mz");

var $hfPJk = parcelRequire("hfPJk");

var $32CBT = parcelRequire("32CBT");

var $ibgjl = parcelRequire("ibgjl");

var $liaOB = parcelRequire("liaOB");

var $2UJ2w = parcelRequire("2UJ2w");
const $5ded9942f908b7ae$export$2ade9573a6e2bedc = ({ isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, title: title, publishButtonDisabled: publishButtonDisabled, userViewingPreview: userViewingPreview, initialFocusTarget: initialFocusTarget, shouldShowWorldIcon: shouldShowWorldIcon, shouldShowFooterButtons: shouldShowFooterButtons = true, onPublishModalComplete: onPublishModalComplete })=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { discardCurrentState: discardCurrentState, hasModifiedSettings: hasModifiedSettings, refetchAll: refetchAll } = (0, $gwFzn.useContext)((0, $ibgjl.PublishModalContext));
    const [publishModalIsOpen, setPublishModalIsOpen] = (0, $gwFzn.useState)(true);
    const [discardModalIsOpen, setDiscardModalIsOpen] = (0, $gwFzn.useState)(false);
    // A ref is needed here so queuedFinalClose can have its value update right away.
    // It is not used in any render functions, so it's OK to use a ref here.
    const queuedFinalCloseRef = (0, $gwFzn.useRef)(false);
    const [focusField, setFocusField] = (0, $gwFzn.useState)(initialFocusTarget);
    const [permissionsDialogIsOpen, setPermissionsDialogIsOpen] = (0, $gwFzn.useState)(false);
    const [selectedRestrictionType, setSelectedRestrictionType] = (0, $gwFzn.useState)(undefined);
    const { isUSDExperimentEnabled: isUSDExperimentEnabled } = (0, $hfPJk.useUnifiedShareDialogEligible)();
    (0, $gwFzn.useEffect)(()=>{
        // We need to refetch the PublishModal state immediately before opening the modal so we can be sure we have the latest settings.
        refetchAll();
    }, [
        refetchAll
    ]);
    const openPermissionsDialog = (chosenContentRestrictionType)=>{
        setPermissionsDialogIsOpen(true);
        setSelectedRestrictionType(chosenContentRestrictionType);
    };
    const closePermissionsDialog = ()=>{
        setPermissionsDialogIsOpen(false);
        setSelectedRestrictionType(undefined);
    };
    /*
	 * The openModal function below opens the publish modal.
	 * It is sometimes used to return to the publish modal after its sub-dialogs (like the permissions dialog) are closed.
	 */ const openModal = (focus)=>{
        setPublishModalIsOpen(true);
        setFocusField(focus);
    };
    // The boolean endPublishExperience should be true if this closes all sub-modals and ends the PublishModal experience.
    // If endPublishExperience is false, the PublishModal will be closed but the PublishModal experience will continue, so other sub-modals like the MovePageDialog can render.
    const closeModal = ({ endPublishExperience: endPublishExperience })=>{
        if (endPublishExperience) queuedFinalCloseRef.current = true;
        setPublishModalIsOpen(false);
    };
    const onCloseComplete = ()=>{
        if (queuedFinalCloseRef.current) onPublishModalComplete();
    };
    const requestCloseModal = ()=>{
        if (hasModifiedSettings) setDiscardModalIsOpen(true);
        else {
            discardCurrentState();
            closeModal({
                endPublishExperience: true
            });
        }
    };
    const closeDiscardModal = ()=>{
        setDiscardModalIsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, publishModalIsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $32CBT.PublishModal), {
        publishButtonDisabled: publishButtonDisabled,
        closeModal: closeModal,
        openModal: openModal,
        requestCloseModal: requestCloseModal,
        onCloseComplete: onCloseComplete,
        isUnpublishedDraft: isUnpublishedDraft,
        openPermissionsDialog: (chosenContentRestrictionType)=>{
            closeModal({
                endPublishExperience: false
            });
            openPermissionsDialog(chosenContentRestrictionType);
        },
        userViewingPreview: userViewingPreview,
        title: title,
        focusField: focusField,
        setFocusField: setFocusField,
        shouldShowWorldIcon: shouldShowWorldIcon,
        shouldShowFooterButtons: shouldShowFooterButtons
    })), (0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled ? permissionsDialogIsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2UJ2w.ShareAndRestrictDialogInPublishModal), {
        contentId: contentId,
        contentType: contentType,
        onClose: ()=>{
            closePermissionsDialog();
            openModal('access');
        },
        isUnpublishedDraft: isUnpublishedDraft
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, permissionsDialogIsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $liaOB.PermissionsDialog), {
        onClose: ()=>{
            closePermissionsDialog();
            openModal('access');
        },
        selectedRestrictionType: selectedRestrictionType,
        contentId: contentId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, discardModalIsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $32CBT.DiscardModal), {
        closeModal: closeModal,
        closeDiscardModal: closeDiscardModal,
        isUnpublishedDraft: isUnpublishedDraft
    })));
};

});
parcelRegister("liaOB", function(module, exports) {

$parcel$export(module.exports, "PermissionsDialog", () => $abfa387bc41cbfc1$export$a4f0286c3ff142a7);

var $gwFzn = parcelRequire("gwFzn");

var $67L2Z = parcelRequire("67L2Z");

var $fL9mQ = parcelRequire("fL9mQ");

var $ibgjl = parcelRequire("ibgjl");
const $abfa387bc41cbfc1$export$a4f0286c3ff142a7 = ({ onClose: onClose, contentId: contentId, selectedRestrictionType: selectedRestrictionType })=>{
    const { restrictionsRestObj: restrictionsRestObj, setRestrictionsRestObj: setRestrictionsRestObj, hasModifiedRestrictions: hasModifiedRestrictions, hasScheduledRestrictions: hasScheduledRestrictions } = (0, $gwFzn.useContext)((0, $ibgjl.PublishModalContext));
    const setRestrictionsDeepCopy = (newVal)=>{
        const clone = (0, (/*@__PURE__*/$parcel$interopDefault($67L2Z)))(newVal);
        setRestrictionsRestObj(clone);
    };
    const preloadRestrictions = hasModifiedRestrictions || hasScheduledRestrictions ? restrictionsRestObj : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fL9mQ.RestrictionsDialogLoader), {
        contentId: contentId,
        submitOverride: setRestrictionsDeepCopy,
        preloadRestrictions: preloadRestrictions,
        preselectRestrictionType: selectedRestrictionType,
        onClose: onClose
    });
};

});

parcelRegister("2UJ2w", function(module, exports) {

$parcel$export(module.exports, "ShareAndRestrictDialogInPublishModal", () => $ebcc7d0d34ae1e7f$export$13cacc04cd9a5e8b);

var $gwFzn = parcelRequire("gwFzn");

var $67L2Z = parcelRequire("67L2Z");

var $lgKMU = parcelRequire("lgKMU");

var $ibgjl = parcelRequire("ibgjl");
const $ebcc7d0d34ae1e7f$export$13cacc04cd9a5e8b = ({ onClose: onClose, contentId: contentId, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft })=>{
    const { restrictionsRestObj: restrictionsRestObj, setRestrictionsRestObj: setRestrictionsRestObj, hasModifiedRestrictions: hasModifiedRestrictions, hasScheduledRestrictions: hasScheduledRestrictions } = (0, $gwFzn.useContext)((0, $ibgjl.PublishModalContext));
    const setRestrictionsDeepCopy = (newVal)=>{
        const clone = (0, (/*@__PURE__*/$parcel$interopDefault($67L2Z)))(newVal);
        setRestrictionsRestObj(clone);
    };
    const preloadRestrictions = hasModifiedRestrictions || hasScheduledRestrictions ? restrictionsRestObj : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lgKMU.ShareAndRestrictDialogController), {
        contentId: contentId,
        contentType: contentType,
        allowRestrictions: true,
        pageModes: "view",
        refetchButtonData: ()=>{},
        onClose: onClose,
        publishModalRestrictions: preloadRestrictions,
        pushPublishModalRestrictions: setRestrictionsDeepCopy,
        isUnpublishedDraft: isUnpublishedDraft
    });
};

});



//# sourceMappingURL=PublishButtonWithMoreOptions.bc732b55.js.map
